import {
  rtkApi,
  GET_MY_NOTIFICATIONS,
  GET_MY_NOTIFICATIONS_UNREAD_COUNT,
} from '@/shared/api/rtkApi';
import { SuccessApiResponse } from '@/shared/types/common';
import type {
  MyNotificationsListParams,
  MyNotificationsListResponse,
  MyNotificationsUnreadCountResponse,
} from './types';

const myNotificationsApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getMyNotificationsUnreadCount: build.query<MyNotificationsUnreadCountResponse, void>({
      query: () => '/notifications/unread-count',
      transformResponse: (response: SuccessApiResponse<MyNotificationsUnreadCountResponse>) =>
        response.data,
      providesTags: [GET_MY_NOTIFICATIONS_UNREAD_COUNT],
    }),
    getMyNotifications: build.query<MyNotificationsListResponse, MyNotificationsListParams>({
      query: (params) => ({
        url: '/notifications',
        params: {
          page: params.page ?? 1,
          pageSize: params.pageSize ?? 8,
          search: params.search || undefined,
          sort: params.sort ?? 'createdAt:desc',
        },
      }),
      transformResponse: (response: SuccessApiResponse<MyNotificationsListResponse>) =>
        response.data,
      providesTags: [GET_MY_NOTIFICATIONS],
    }),
    deleteMyNotification: build.mutation<void, number>({
      query: (id) => ({
        url: `/notifications/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [GET_MY_NOTIFICATIONS],
    }),
    markMyNotificationAsRead: build.mutation<void, number>({
      query: (id) => ({
        url: `/notifications/${id}/mark-as-read`,
        method: 'PUT',
      }),
      invalidatesTags: [GET_MY_NOTIFICATIONS],
      async onQueryStarted(_id, { dispatch, queryFulfilled }) {
        const patchUnread = dispatch(
          myNotificationsApi.util.updateQueryData(
            'getMyNotificationsUnreadCount',
            undefined,
            (state) => {
              if (state.count > 0) {
                state.count -= 1;
              }
            },
          ),
        );

        try {
          await queryFulfilled;
        } catch {
          patchUnread.undo();
        }
      },
    }),
  }),
});

export const {
  useGetMyNotificationsUnreadCountQuery,
  useGetMyNotificationsQuery,
  useMarkMyNotificationAsReadMutation,
  useDeleteMyNotificationMutation,
} = myNotificationsApi;

export { myNotificationsApi };
